import request from "@/utils/request";

export function getCampaign(query) {
  return request({
    url: "/campaign",
    method: "get",
    params: query,
  });
}

export function checkShareLine(query) {
  return request({
    url: "/share",
    method: "get",
    params: query,
  });
}

export function joinCampaign(data) {
  return request({
    url: "/join_campaign",
    method: "post",
    data: data,
  });
}

export function retryCampaign(data) {
  return request({
    url: "/retry",
    method: "post",
    data: data,
  });
}

export function enretryCampaign(query) {
  return request({
    url: "/enretry",
    method: "get",
    params: query,
  });
}

export function sharedCampaign(data) {
  return request({
    url: "/shared",
    method: "post",
    params: data,
  });
}
